import type * as Blockly from 'blockly/core';
import { BOARD_CONFIG } from '@/(routers)/boards/editor/block/blockConfig';
import {
    registerHelperFunction,
    registerSetupCode,
    resolveBoard,
    stmt,
} from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import {
    GPS_BASE_HELPER_CODE,
    GPS_BASE_HELPER_CODE_BLUE,
    GPS_POSITION_LABELS,
    gpsGlobalCode,
    gpsGlobalCodeBlue,
    gpsGlobalCodes,
    markGpsUsed,
} from '@/(routers)/boards/editor/block/generators/arduino/blocks/gps/helper/gps_helper';
import { variableDeclarations } from '@/(routers)/boards/editor/block/generators/arduino/blocks/variable/variable';

type Position = keyof (typeof BOARD_CONFIG)[keyof typeof BOARD_CONFIG]['pins'];

const LOCATION_HELPER_CODE = `void _sbeGpsReadLocation(TinyGPSPlus* gps, SoftwareSerial* serial, float* lat, float* lng, bool* warned, const char* label) {
  _sbeGpsCheckAge(gps, serial, warned, label);
  *lat = gps->location.isValid() ? gps->location.lat() : 0;
  *lng = gps->location.isValid() ? gps->location.lng() : 0;
}`;

const LOCATION_HELPER_CODE_BLUE = `void _sbeGpsReadLocation_blue(TinyGPSPlus* gps, float* lat, float* lng, bool* warned, const char* label) {
  _sbeGpsCheckAge_blue(gps, warned, label);
  *lat = gps->location.isValid() ? gps->location.lat() : 0;
  *lng = gps->location.isValid() ? gps->location.lng() : 0;
}`;

export function register(gen: any): void {
    gen.forBlock['gps_location'] = function (block: Blockly.Block): string {
        const position = block.getFieldValue('POSITION') as Position;
        const latVar = block.getFieldValue('LAT_VAR') as string;
        const lngVar = block.getFieldValue('LNG_VAR') as string;

        if (!latVar || latVar === '設定する変数') return '';
        if (!lngVar || lngVar === '設定する変数') return '';

        const board = resolveBoard(block);
        const pins = BOARD_CONFIG[board].pins[position];
        const rx = pins.second;
        const tx = pins.first;
        const label = GPS_POSITION_LABELS[position] ?? position;

        markGpsUsed();
        variableDeclarations.set(latVar, `float ${latVar} = 0;\n`);
        variableDeclarations.set(lngVar, `float ${lngVar} = 0;\n`);

        if (board === 'blue') {
            gpsGlobalCodes.set(`${tx}`, gpsGlobalCodeBlue(tx));
            registerHelperFunction('gps_base', GPS_BASE_HELPER_CODE_BLUE);
            registerHelperFunction('gps_location_fn', LOCATION_HELPER_CODE_BLUE);
            registerSetupCode(
                `gps_${tx}`,
                `  Serial2.begin(9600, SERIAL_8N1, ${rx}, ${tx});\n  _sbeGpsBegin_blue("${label}");\n`,
            );
            return stmt(
                `_sbeGpsReadLocation_blue(&_sbeGps_${tx}, &${latVar}, &${lngVar}, &_sbeGpsWarned_${tx}, "${label}")`,
            );
        }

        gpsGlobalCodes.set(`${tx}`, gpsGlobalCode(rx, tx));
        registerHelperFunction('gps_base', GPS_BASE_HELPER_CODE);
        registerHelperFunction('gps_location_fn', LOCATION_HELPER_CODE);
        registerSetupCode(`gps_${tx}`, `  _sbeGpsBegin(&_sbeGpsSerial_${tx}, "${label}");\n`);
        return stmt(
            `_sbeGpsReadLocation(&_sbeGps_${tx}, &_sbeGpsSerial_${tx}, &${latVar}, &${lngVar}, &_sbeGpsWarned_${tx}, "${label}")`,
        );
    };
}
